(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('rcopia-drug', {
                parent: 'entity',
                url: '/rcopia-drug',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Rcopia - Drugs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-drug/list/rcopia-drug.html',
                        controller: 'RcopiaDrugController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
